// @ts-expect-error pure js
import useResource from "./use-resource.js";
import type { ComptaCompleteness } from "../models/comptaFinding";

interface UseComptaCompleteness {
  completeness: ComptaCompleteness | null;
  isLoading: boolean;
}

export default function useComptaCompleteness(
  fiscalYear: number,
): UseComptaCompleteness {
  const { resource: completeness, isLoading } = useResource(
    "/compta/completeness",
    { params: { fiscal_year: fiscalYear } },
  );

  return { completeness, isLoading };
}
